import { FareFamilyPriceFragment } from '@websky/graphql';
import { SelectedFare } from '../../types';

export const isFareGroupAvailable = (group: FareFamilyPriceFragment, lastSelectedFare: SelectedFare) => {
	let canCombineWithPreviousSelectedFare = true;

	if (lastSelectedFare) {
		const lastSelectedFareFlightsIds = lastSelectedFare.prices.map(price => price.flight.id);

		canCombineWithPreviousSelectedFare = group?.prices?.some(price =>
			lastSelectedFareFlightsIds.includes(price.flight.id)
		);
	}

	return group.prices && canCombineWithPreviousSelectedFare;
};

export const findIndexFirstAvailableFareGroup = (
	fareGroups: FareFamilyPriceFragment[],
	lastSelectedFare: SelectedFare
) => {
	const index = fareGroups.findIndex(group => isFareGroupAvailable(group, lastSelectedFare));

	return index === -1 ? null : index;
};

export const roundAvailableSliderIndex = (sliderIndex: number, slidesToScroll: number) => {
	if (sliderIndex < slidesToScroll || !sliderIndex) {
		return 0;
	}

	let offset = 0;
	while ((sliderIndex - offset) % slidesToScroll !== 0) {
		offset++;
	}

	return sliderIndex - offset;
};

export const isFaresHasOneItem = (fares: FareFamilyPriceFragment[]) => fares?.length === 1;

export const isShowFaresPagination = (fares: FareFamilyPriceFragment[]) => fares?.length > 1;
